import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";

const LOGO_URL = "/images/Logo.png";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{ backgroundColor: "#2d5016", color: "#eae4d8" }}
      className="pt-14 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12" style={{ borderBottom: "1px solid rgba(234,228,216,0.2)" }}>
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <div className="rounded-xl p-3" style={{ backgroundColor: "#eae4d8" }}>
                <img src={LOGO_URL} alt="Torcé Biomasse Energie" loading="lazy" decoding="async" className="h-24 w-auto" />
              </div>
            </Link>
            <p className="text-sm leading-relaxed opacity-80" style={{ fontFamily: "'Satoshi', sans-serif" }}>
              Producteur de miscanthus en Sarthe. Rhizomes, paillage et biomasse issus d'une agriculture durable et locale.
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm opacity-70">
              <MapPin size={14} style={{ color: "#b57a3e" }} />
              <span>Torcé en Vallée — Sarthe, Pays de la Loire</span>
            </div>
          </div>

          {/* Le Miscanthus */}
          <div>
            <h4 className="font-body font-700 text-sm uppercase tracking-wider mb-4" style={{ color: "#b57a3e" }}>Le Miscanthus</h4>
            <ul className="space-y-2">
              {[
                { label: "La plante", href: "/le-miscanthus" },
                { label: "La paille de Miscanthus", href: "/la-paille" },
                { label: "Les rhizomes & plantation", href: "/les-rhizomes" },
                { label: "FAQ technique", href: "/faq" },
              ].map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-sm transition-opacity hover:opacity-100 opacity-75" style={{ fontFamily: "'Satoshi', sans-serif" }}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* L'exploitation */}
          <div>
            <h4 className="font-body font-700 text-sm uppercase tracking-wider mb-4" style={{ color: "#b57a3e" }}>L'Exploitation</h4>
            <ul className="space-y-2">
              {[
                { label: "Nos Produits", href: "/produits" },
                { label: "L'Exploitation", href: "/exploitation" },
                { label: "Témoignages", href: "/#temoignages" },
              ].map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-sm transition-opacity hover:opacity-100 opacity-75" style={{ fontFamily: "'Satoshi', sans-serif" }}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body font-700 text-sm uppercase tracking-wider mb-4" style={{ color: "#b57a3e" }}>Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm opacity-75">
                <Mail size={14} style={{ color: "#b57a3e" }} />
                <a href="mailto:contact@miscanthus-sarthe.fr" className="hover:opacity-100 transition-opacity">
                  contact@miscanthus-sarthe.fr
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm opacity-75">
                <MapPin size={14} style={{ color: "#b57a3e" }} />
                <span>Sarthe — Pays de la Loire</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="inline-block mt-4 px-4 py-2 text-sm rounded-md font-body font-500 transition-colors"
              style={{ backgroundColor: "#b57a3e", color: "white" }}
              data-testid="footer-contact-cta"
            >
              Demander un devis
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs opacity-50" style={{ fontFamily: "'Satoshi', sans-serif" }}>
            © 2026 EARL Torcé Biomasse Energie — Sarthe, Pays de la Loire
          </p>
          <div className="flex items-center gap-4 text-xs opacity-50">
            <span>EARL Torcé Biomasse Energie</span>
            <span>·</span>
            <span>Mentions légales</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
